module.exports = __webpack_public_path__ + "img/voortuin a v solmsstr na.5531626d.jpg";